"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileOrgSwitcher = exports.DesktopOrgSwitcher = exports.OrgSwitcher = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactResponsive = require("react-responsive");

var _helpers = require("../../helpers");

var _AsyncSelectSingle = require("../Select/AsyncSelectSingle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _styledComponents.default.div.withConfig({
  displayName: "Option",
  componentId: "sc-1059mcn-0"
})(["display:flex;box-sizing:border-box;outline:none;max-width:100%;margin:0px;min-width:0;min-height:0;flex-direction:column;flex:0 0 auto;padding:0px;", " a{display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;text-decoration:none;padding:12px;color:", ";", "}"], function (_ref) {
  var selected = _ref.selected,
      theme = _ref.theme;
  return selected ? "background: ".concat((0, _helpers.color)('brand')({
    theme: theme
  }), ";") : '';
}, (0, _helpers.color)('black'), function (_ref2) {
  var selected = _ref2.selected;
  return selected ? " color: #ffffff; " : '';
});
/* Only string values are allowed */


var OrgSwitcher = function OrgSwitcher(_ref3) {
  var currentOrgId = _ref3.currentOrgId,
      _ref3$organisations = _ref3.organisations,
      organisations = _ref3$organisations === void 0 ? [] : _ref3$organisations,
      _ref3$id = _ref3.id,
      id = _ref3$id === void 0 ? '' : _ref3$id;
  var currentOrganisation = organisations.find(function (_ref4) {
    var value = _ref4.value;
    return value === currentOrgId;
  });
  var disabled = organisations.length <= 1;

  var searchOrgs = function searchOrgs(search) {
    var matcher = new RegExp(search, 'i');
    return Promise.resolve(organisations.filter(function (_ref5) {
      var label = _ref5.label;
      return matcher.test(label);
    }));
  };

  return _react.default.createElement(_AsyncSelectSingle.AsyncSelectSingle, {
    value: currentOrganisation,
    options: organisations,
    fetchOptions: searchOrgs,
    disabled: disabled,
    placeholder: "Select Organisation",
    id: "orgSwitcher".concat(id),
    onChange: function onChange(option) {
      window.location.href = "".concat(window.location.origin, "/organisation/").concat(option.value);
    },
    renderOption: function renderOption(option) {
      return _react.default.createElement(Option, {
        selected: option.value === currentOrgId
      }, _react.default.createElement("a", {
        href: "".concat(window.location.origin, "/organisation/").concat(option.value)
      }, option.label));
    }
  });
};

exports.OrgSwitcher = OrgSwitcher;

var DesktopOrgWrapper = _styledComponents.default.div.withConfig({
  displayName: "DesktopOrgWrapper",
  componentId: "sc-1059mcn-1"
})(["padding:6.5px 8px;height:56px;"]);

var DesktopOrgSwitcher = function DesktopOrgSwitcher(props) {
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1040px)'
  });
  return isDesktop ? _react.default.createElement(DesktopOrgWrapper, null, _react.default.createElement(OrgSwitcher, props)) : null;
};

exports.DesktopOrgSwitcher = DesktopOrgSwitcher;

var MobileOrgWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileOrgWrapper",
  componentId: "sc-1059mcn-2"
})(["padding:8px;"]);

var MobileOrgSwitcher = function MobileOrgSwitcher(props) {
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1040px)'
  });
  return isDesktop ? null : _react.default.createElement(MobileOrgWrapper, null, _react.default.createElement(OrgSwitcher, props));
};

exports.MobileOrgSwitcher = MobileOrgSwitcher;